import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Calendar from 'rc-year-calendar';
import 'rc-year-calendar/locales/rc-year-calendar.cs';
import 'rc-year-calendar/locales/rc-year-calendar.de';
import 'rc-year-calendar/locales/rc-year-calendar.es';
import 'rc-year-calendar/locales/rc-year-calendar.fi';
import 'rc-year-calendar/locales/rc-year-calendar.fr';
import 'rc-year-calendar/locales/rc-year-calendar.hr';
import 'rc-year-calendar/locales/rc-year-calendar.hu';
import 'rc-year-calendar/locales/rc-year-calendar.it';
import 'rc-year-calendar/locales/rc-year-calendar.lv';
import 'rc-year-calendar/locales/rc-year-calendar.pt';
import 'rc-year-calendar/locales/rc-year-calendar.pl';
import 'rc-year-calendar/locales/rc-year-calendar.ru';
import 'rc-year-calendar/locales/rc-year-calendar.sk';
import ReactDOMServer from 'react-dom/server';
import {
  AppCard,
  AppModal,
  AppNoInfo,
  AppRemixIcon,
} from '@/layout/AppComponents';
import { ProgressBar } from 'react-bootstrap';
import Moment from 'moment';
import * as moduleAction from '../../../store/actions/moduleAction';
import BreadcrumbHandler from '../../../layout/components/breadcrumb/BreadcrumbHandler';
import useIsMounted from '../../../layout/components/hooks/useIsMounted';
import errorHandler from '@/layout/components/error/ErrorHandler';
import { axiosPath } from '../../../routing/helpers/router';
import Translator from '../../../layout/components/helpers/Translator';
import ResourceManagerSidebar from '../../../layout/screenSpecifics/Modules/ResourceManager/Sidebar/ResourceManagerSidebar';
import colors from '../../../constants/colors';
import ResourceManagerCalendarFilters from '../../../layout/screenSpecifics/Modules/ResourceManager/Calendar/ResourceManagerCalendarFilters';
import { getNextDateHuman } from '../../../layout/screenSpecifics/Modules/ResourceManager/tools/resourceManagerTools';
import PreventNavigation from '../../../layout/components/helpers/PreventNavigation';

export default function ModuleResourceManagerCalendarScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const moduleData = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.moduleData,
  );
  const isMounted = useIsMounted();
  const global = useSelector((state) => state.global);
  const [currentYearCalendarData, setCurrentYearCalendarData] = useState();
  const [filteredCalendarData, setFilteredCalendarData] = useState();
  const [isLoading, setIsLoading] = useState();
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [maxDate] = useState(Moment(`${currentYear + 1}-12-31`).toDate());
  const [previsions, setPrevisions] = useState();
  const [showXlsModal, setShowXlsModal] = useState();
  const [batchLoop, setBatchLoop] = useState();
  const [showLoopModal, setShowLoopModal] = useState();

  // PARA CAMBIAR A FUTURO A COMPONENTE O SIMILAR
    if (!moduleBridgeHex || !moduleData) {
      <AppNoInfo />;
    }
    // > LOAD MODULE DATA //
    const loadModuleData = useCallback(async () => {
      dispatch(
        moduleAction.fetch(
          axiosPath('api_r_user_module_resourceManager_getModuleData'),
          'moduleData',
          {
            moduleBridgeHex,
          },
        ),
      );
    }, []);

    useEffect(() => {
        !moduleData && loadModuleData();
      }, []);
    // > LOAD MODULE DATA //
    // < STORE CALLS
    const loadModulePermissions = useCallback(async () => {
      try {
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'permissions',
            {
              moduleBridgeHex,
              subType: 'permissions',
            },
          ),
        );
        await dispatch(
          moduleAction.fetch(
            axiosPath('api_r_user_module_resourceManager_getPermissions'),
            'userBridge',
            {
              moduleBridgeHex,
              subType: 'userBridge',
            },
          ),
        );
      } catch (err) {}
    }, [moduleBridgeHex]);

    useEffect(() => {
      loadModulePermissions();
    }, [moduleBridgeHex]);
    // < STORE CALLS

  // > LOAD RESOURCES
  const loadPrevisions = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            'api_r_user_module_resourceManager_calendar_prevision_list',
          ),
          {
            moduleBridgeHex,
            currentYear,
          },
        )
        .then(({ data }) => {
          if (isMounted.current) {
            const calendarData = data.map((cd) => ({
              ...cd,
              startDate: Moment(cd.startDate, 'DD/MM/YYYY').toDate(),
              endDate: Moment(cd.startDate, 'DD/MM/YYYY').toDate(),
            }));
            setCurrentYearCalendarData(calendarData);
            setFilteredCalendarData(calendarData);
          }
          setIsLoading(false);
        })
        .catch((e) => dispatch(errorHandler(e))),
    [moduleBridgeHex, currentYear],
  );

  useEffect(() => {
    setIsLoading(true);
    loadPrevisions();
  }, [currentYear]);
  // < LOAD RESOURCES

  // > REDIRECT TO PLANT WITH OBLIGATION FILTER
  const createFilterAndRedirect = useCallback(
    async (mbh, plantHex, obligationID) => {
      return axios
        .post(
          axiosPath(
            'api_r_user_module_resourceManager_generateFilterHexCodeWithObligationIDs',
          ),
          {
            moduleBridgeHex: mbh,
            obligationID,
          },
        )
        .then(({ data }) => {
          if (data?.hexCode) {
            window.open(
              `${global.urlData.rootProject}r/legal-compliance/${moduleBridgeHex}/evaluation/${plantHex}/1/${data?.hexCode}/`,
              '_blank',
            );
          }
        })
        .catch((e) => dispatch(errorHandler(e)));
    },
    [],
  );
  // < REDIRECT TO PLANT WITH OBLIGATION FILTER

  const filterCalendarData = useCallback(
    (filters) => {
      const updatedCurrentYearCalendarData = [...currentYearCalendarData];
      const filterObligationHex =
        filters?.obligationHex !== '' ? filters?.obligationHex.split(',') : [];

      setPrevisions([]);
      setFilteredCalendarData(
        updatedCurrentYearCalendarData.filter(
          (cd) =>
            (!filterObligationHex.length ||
              filterObligationHex.includes(cd?.obligation?.hex)) &&
            (!filters?.resources.length ||
              filters?.resources.includes(cd?.resource?.hex)) &&
            (!filters?.categories.length ||
              filters?.categories.includes(cd?.resource?.category)),
        ),
      );
    },
    [currentYearCalendarData],
  );

  const handleReset = useCallback(() => {
    setPrevisions([]);
    setFilteredCalendarData(currentYearCalendarData);
  }, [currentYearCalendarData]);

  const calendarController = (e) => {
    if (e.events.length > 0) setPrevisions(e.events);
  };

  // > EXPORT XLS
  const exportXls = useCallback(
    async (filters) => {
      let values = {
        moduleBridgeHex,
        tempBatchLoopID: batchLoop?.tempBatchLoopID || null,
        filters,
      };

      if (!batchLoop?.tempBatchLoopID) {
        values = {
          ...values,
          ...batchLoop,
        };
      }

      axios
        .post(
          axiosPath('api_r_user_module_resourceManager_calendar_xls_download'),
          values,
        )
        .then(({ data }) => {
          if (isMounted.current) {
            setBatchLoop(data);
          }
        })
        .catch((e) => dispatch(errorHandler(e)));
    },
    [moduleBridgeHex, batchLoop],
  );

  useEffect(() => {
    if (batchLoop && !batchLoop?.isFinished) {
      setShowXlsModal(false);
      if (!showLoopModal) setShowLoopModal(true);
      exportXls();
    } else if (batchLoop?.isFinished && batchLoop?.url) {
      setShowLoopModal(undefined);
      setBatchLoop(undefined);
      window.location = batchLoop?.url;
    }
  }, [batchLoop]);
  // < EXPORT XLS

  return (
    <>
      <ResourceManagerSidebar activeRoute="user_module_resourceManager_calendar" />
      <BreadcrumbHandler
        paths={
          moduleData
            ? [{ name: `${moduleData?.moduleName}` }]
            : [{ name: '...' }]
        }
      />
      <main role="main" className="col-md-12 col-lg-12 px-md-4">
        <div className="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-0 pb-0 mb-0">
          <AppCard
            header={
              <span
                className="btn btn-success btn-xs float-right"
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-resourceManager"
                    name="resource.generate-excel"
                  />,
                )}
                onClick={() => setShowXlsModal(true)}
              >
                <AppRemixIcon icon="file-excel" />
              </span>
            }
          >
            {!isLoading && filteredCalendarData ? (
              <>
                <ResourceManagerCalendarFilters
                  currentYear={currentYear}
                  onHandleFilters={filterCalendarData}
                  onReset={handleReset}
                />
                <div className="mt-3">
                  <Calendar
                    language={global?.urlData?.lang}
                    dataSource={filteredCalendarData}
                    style="background"
                    onDayClick={calendarController}
                    onYearChanged={(e) => setCurrentYear(e.currentYear)}
                    year={currentYear}
                    maxDate={maxDate}
                  />
                  {previsions?.length > 0 && (
                    <div className="mt-4">
                      <h5>{ReactDOMServer.renderToString(
                        <Translator
                          file="module-resourceManager"
                          name="resource.planned.actions"
                        />
                      )}</h5>
                      <div className="table-responsive">
                        <table className="table table-hover table-sm">
                          <thead>
                            <tr>
                              <th className="col-sm-2">
                                <Translator
                                  file="module-resourceManager"
                                  name="resource.period"
                                />
                              </th>
                              <th className="col-sm-2">
                                <Translator
                                  file="module-resourceManager"
                                  name="resource.frequency"
                                />
                              </th>
                              <th className="col-sm-3">
                                <Translator
                                  file="module-resourceManager"
                                  name="resource.asset"
                                />
                              </th>
                              <th className="col-sm-3">
                                <Translator
                                  file="module-resourceManager"
                                  name="resource.obligation"
                                />
                              </th>
                              <th className="col-sm-2">
                                <Translator
                                  file="module-resourceManager"
                                  name="resource.installation"
                                />
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {previsions?.map((p) => (
                              <tr key={p?.id}>
                                <td
                                  className={
                                    p?.state === 1
                                      ? 'text-success'
                                      : p?.state === 2
                                        ? 'text-warning'
                                        : p?.state === 3
                                          ? 'text-danger'
                                          : p?.state === 0
                                            ? ''
                                            : 'text-warning'
                                  }
                                >
                                  <AppRemixIcon
                                    className="mr-2"
                                    icon={
                                      p?.state === 1
                                        ? 'check'
                                        : [3, 2].includes(p?.state)
                                          ? 'alert'
                                          : 'calendar-schedule'
                                    }
                                    color={
                                      p?.state === 0
                                        ? '#000'
                                        : p?.state === 1
                                          ? colors.success
                                          : p?.state === 2
                                            ? colors.state2
                                            : colors.danger
                                    }
                                  />
                                  <span>{p.dateRange}</span>
                                </td>
                                <td>
                                  {p?.nextDateSettings
                                    ? getNextDateHuman(p?.nextDateSettings)
                                    : '--'}
                                </td>
                                <td>{p?.resource?.name}</td>
                                <td
                                  dangerouslySetInnerHTML={{
                                    __html: p?.obligation?.name,
                                  }}
                                />
                                <td>
                                  {p?.plant?.plantHex ? (
                                    <span
                                      className="pointer text-primary"
                                      onClick={() =>
                                        createFilterAndRedirect(
                                          p?.plant?.moduleBridgeHex,
                                          p?.plant?.plantHex,
                                          p?.obligation?.id,
                                        )
                                      }
                                    >
                                      {p?.plant?.plantName}
                                      <AppRemixIcon
                                        className="ml-1"
                                        icon="external-link"
                                      />
                                    </span>
                                  ) : (
                                    '-'
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <AppModal
                  show={showXlsModal}
                  size="lg"
                  title={
                    <Translator
                      file="module-resourceManager"
                      name="resource.export.planned.actions.excel"
                    />
                  }
                  onClose={() => setShowXlsModal(false)}
                  isConfirmBtn={false}
                >
                  <ResourceManagerCalendarFilters
                    currentYear={currentYear}
                    onHandleFilters={exportXls}
                    isXls
                  />
                </AppModal>
                <AppModal
                  show={showLoopModal}
                  title={
                    <Translator
                      file="module-resourceManager"
                      name="resource.export.of.planned.actions"
                    />
                  }
                  isCloseButton={false}
                >
                  <>
                    {!batchLoop?.isFinished && <PreventNavigation />}

                    <h4>
                      {batchLoop?.modalInfo?.message || (
                        <Translator
                          file="admin"
                          name="general.precalculating"
                        />
                      )}
                    </h4>
                    <ProgressBar
                      animated
                      now={batchLoop?.modalInfo?.percent || 0}
                      label={`${parseInt(
                        batchLoop?.modalInfo?.percent || 0,
                        10,
                      )}%`}
                    />
                  </>
                </AppModal>
              </>
            ) : (
              <AppNoInfo
                text={`${ReactDOMServer.renderToString(
                  <Translator file="general" name="loading" />,
                )}...`}
              />
            )}
          </AppCard>
        </div>
      </main>
    </>
  );
}
